<router-outlet></router-outlet> 
<app-loader></app-loader>
<button style='display:none' id='openclosedStoreInfo' (click)="ClosedStoreInfo(InfoTemplate)"></button>
<ng-template #InfoTemplate>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>{{informessage}} </p>
          </div>
          <div class="button-div text-center mt-3 align-items-center">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">ok</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>